import { CategoryNode, ShowingType } from './types'

export const findCategoryById = (
  categoriesList: CategoryNode[],
  targetId: string
): CategoryNode | null => {
  for (const category of categoriesList) {
    if (category.category_id.toString() === targetId) {
      return category
    }
    if (category.subcategories) {
      const found = findCategoryById(category.subcategories, targetId)
      if (found) return found
    }
  }
  return null
}

export const collectAllCardIds = (category: CategoryNode): number[] => {
  let cardIds: number[] = []


  // Добавляем card_ids из текущей категории
  if (category.card_ids && category.card_ids.length > 0) {
    cardIds = [...cardIds, ...category.card_ids]
   
  }

  // Рекурсивно добавляем card_ids из всех подкатегорий
  if (category.subcategories && category.subcategories.length > 0) {
   
    for (const subcategory of category.subcategories) {
      const subCardIds = collectAllCardIds(subcategory)
      cardIds = [...cardIds, ...subCardIds]
    }
  } 
  return cardIds
}

export const getItemCount = (item: any, showingType: ShowingType): string => {
  if (showingType === 'subcategories') {
    if (item.card_ids) {
      return `${item.card_ids.length} рецептов`
    } else if (item.subcategories) {
      const totalCards = item.subcategories.reduce(
        (acc: number, sub: any) => {
          return acc + (sub.card_ids ? sub.card_ids.length : 0)
        },
        0
      )
      return `${totalCards} рецептов`
    }
    return ''
  } else {
    // Для карточек показываем категории
    if (item.categories && item.categories.length > 0) {
      return (
        item.categories[0].name +
        (item.categories.length > 1 ? ` +${item.categories.length - 1}` : '')
      )
    }
    return ''
  }
}

export const getItemLink = (item: any, showingType: ShowingType): string => {
  if (showingType === 'subcategories') {
    return `/category/${item.category_id}`
  } else if (showingType === 'courses') {
    return `/courses/${item.base?.course_id || item.course_id}`
  } else {
    // Поддерживаем настраиваемую ссылку для произвольных карточек (тизеров)
    return item.link || `/card/${item.card_id}`
  }
}

export const getItemId = (item: any, showingType: ShowingType): number => {
  if (showingType === 'subcategories') {
    return item.category_id
  } else if (showingType === 'courses') {
    return item.base?.course_id || item.course_id
  } else {
    return item.card_id
  }
}

export const getItemName = (item: any, showingType: ShowingType): string => {
  if (showingType === 'subcategories') {
    return item.name
  } else if (showingType === 'courses') {
    return item.base?.name || item.name
  } else {
    return item.title
  }
}

export const getItemIcon = (item: any, showingType?: ShowingType): string => {
  if (showingType === 'courses') {
    return item.base?.preview_icon_url || item.preview_icon_url || item.icon_url
  }
  return item.icon_url
} 